import { z } from '@hono/zod-openapi'
import { benefitClaimsTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertBenefitClaim = z.infer<typeof zInsertBenefitClaim>
export type SelectBenefitClaim = z.infer<typeof zSelectBenefitClaim>
export type UpdateBenefitClaim = z.infer<typeof zUpdateBenefitClaim>
export type QueryBenefitClaims = z.infer<typeof zQueryBenefitClaims>
export type ColumnsOfBenefitClaimsTable =
    keyof typeof benefitClaimsTable._.columns

export const zSelectBenefitClaim = createSelectSchema(benefitClaimsTable)
export const zInsertBenefitClaim = createInsertSchema(benefitClaimsTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateBenefitClaim = zInsertBenefitClaim.partial()
export const zQueryBenefitClaims = zInsertBenefitClaim
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()
